import { composeIO } from 'react-compose-io'
import { modalRegularizarPerdasDebitoIO } from './ModalRegularizarPerdasDebito.IO'
import ModalRegularizarPerdasDebitoView from './ModalRegularizarPerdasDebito.View'

export const ModalRegularizarPerdasDebito = composeIO(ModalRegularizarPerdasDebitoView, modalRegularizarPerdasDebitoIO)
